import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC001_Request,
  IAPI_FAC001_Response,
  IAPI_FAC013_Request,
  IAPI_FAC013_Response,
} from "../../../type/apiType";

// 「施設を転換後加入させない旨の届」の取り下げ対象一覧参照
// API仕様書_施設
const httpIAPI_FAC001 = async (
  param: IAPI_FAC001_Request
): Promise<IAPI_FAC001_Response> => {
  let res = await http.post(ApiUrl.API_FAC001, {
    ...param,
  });
  return res.data;
};

// 施設を転換後加入させない旨の取下届更新
// API仕様書_施設
const httpIAPI_FAC013 = async (
  param: IAPI_FAC013_Request
): Promise<IAPI_FAC013_Response> => {
  let res = await http.post(ApiUrl.API_FAC013, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_FAC001, httpIAPI_FAC013 };
